import { useLanguage } from '../context/LanguageContext';
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, ShoppingBag, ArrowRight, Loader2 } from 'lucide-react';
import { publicApi } from '../context/AuthContext';

export default function PaymentSuccess() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [confirming, setConfirming] = useState(true);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const confirmPayment = async () => {
      if (token) {
        try {
          await publicApi.post(`/payment/${token}/confirm`);
          const response = await publicApi.get(`/payment/${token}`);
          setOrder(response.data);
        } catch (err) {
          console.error('Error confirming payment:', err);
        }
      }
      setConfirming(false);
    };

    confirmPayment();
  }, [token]);

  if (confirming) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-[#00aaff] mx-auto mb-4" />
          <p className="text-gray-600">Confirmation de votre paiement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white py-12 px-4">
      <div className="max-w-lg mx-auto text-center">
        {/* Success Icon */}
        <div className="mb-8">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
            <CheckCircle className="w-14 h-14 text-green-500" />
          </div>
          <h1 className="text-3xl font-black text-gray-900 mb-2">{t('payment.success')} !</h1>
          <p className="text-gray-600">Merci pour votre commande</p>
        </div>

        {/* Order Info Card */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 text-left">
          <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-100">
            <ShoppingBag className="w-6 h-6 text-[#00aaff]" />
            <div>
              <p className="text-sm text-gray-500">Commande</p>
              <p className="font-bold text-gray-900">#{order?.order_number || 'N/A'}</p>
            </div>
          </div>

          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">Client</span>
              <span className="font-medium text-gray-900">{order?.customer_name}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">Email</span>
              <span className="font-medium text-gray-900">{order?.customer_email}</span>
            </div>
            <div className="flex justify-between pt-3 border-t border-gray-100">
              <span className="text-gray-500">Total payé</span>
              <span className="font-bold text-lg text-green-600">{order?.total_ttc?.toFixed(2)}€</span>
            </div>
          </div>
        </div>

        {/* Next Steps */}
        <div className="bg-blue-50 rounded-xl p-4 mb-8 text-left">
          <p className="font-semibold text-blue-900 mb-2">Et maintenant ?</p>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>✓ Un email de confirmation vous a été envoyé</li>
            <li>✓ Votre commande est en cours de préparation</li>
            <li>✓ Vous recevrez un email avec le suivi de livraison</li>
          </ul>
        </div>

        {/* CTA */}
        <Link
          to="/collection"
          className="inline-flex items-center gap-2 bg-[#00aaff] text-white px-8 py-4 rounded-xl font-bold hover:bg-[#0088cc] transition-colors"
        >
          Continuer mes achats
          <ArrowRight className="w-5 h-5" />
        </Link>

        {/* Footer */}
        <p className="mt-8 text-sm text-gray-400">
          Une question ? Contactez-nous à contact@joeycyan.com
        </p>
      </div>
    </div>
  );
}
